import React from 'react';
import { Modal } from 'semantic-ui-react';
import { bool, arrayOf, string, func } from 'prop-types';

import urlEncode from '../urlEncode';
import ModalBody from './ModalBody';
import StationNotFound from './StationNotFound';

const StationModal = ({
  loadingStations,
  terms,
  stations,
  playStation,
  modalIsVisible,
  hideModal,
  match
}) => {
  const { params } = match;
  const station =
    !loadingStations && params.stationName
      ? stations.filter(
          item =>
            urlEncode(item.name).toUpperCase() ===
            params.stationName.toUpperCase()
        )[0]
      : {};

  return (
    !loadingStations && (
      <Modal open={modalIsVisible} onClose={() => hideModal()} closeIcon>
        {station ? (
          <ModalBody
            station={station}
            playStation={playStation}
            terms={terms}
          />
        ) : (
          <StationNotFound
            hideModal={hideModal}
            matchUrl={params.stationName}
            terms={terms}
          />
        )}
      </Modal>
    )
  );
};

StationModal.propTypes = {
  loadingStations: bool.isRequired,
  terms: arrayOf(string).isRequired,
  playStation: func.isRequired,
  modalIsVisible: bool.isRequired,
  hideModal: func.isRequired
};

export default StationModal;
